import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sendback-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css'],
})
export class CommentComponent implements OnInit {
  @Input() comment?: string;
  
  ngOnInit() {
    console.log(this.comment);
  }
}
